<div class="form-group">


<div  *ngFor="let item of subformRecords; let i = index">

  <div class="subform-item-title" ><h6>{{subformTitle}} {{i+1}}</h6><div *ngIf="editionEnabled" class="align-right">
    <button *ngIf="ocurrencies == 0" nbButton size="small" status="danger" (click)="deleteOccurency(i)"><nb-icon icon="trash-2-outline"></nb-icon></button></div></div>

  <ngx-customform #ocurrency [enableEdition]="editionEnabled" [loadCustomform]="customform" [loadReport]="item"></ngx-customform>

</div>

<button *ngIf="editionEnabled && ocurrencies == 0" nbButton size="small" fullWidth status="success" (click)="addOcurrency()">Añadir {{subformTitle}}</button>
</div>
